export default __webpack_public_path__ + "static/media/home-consulting-tab-img-01.ff94ef0e.jpg";